import common from 'assets/themes/vacances-campings/js/page/common/index'

export default function (): void {
  if ('IntersectionObserver' in window) {
    let bestOfferSticky = false

    const targetEl = document.querySelector('.top__block')
    const bestOfferEl = document.querySelector('.product__best-offer')

    if (bestOfferEl && targetEl) {
      const bestOfferObserver = new window.IntersectionObserver(
        (entries) => {
          if (bestOfferEl) {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                bestOfferEl.classList.add('best-offer--hidden')
              } else {
                bestOfferEl.classList.remove('best-offer--hidden')
              }
            })
          }
        },
        {
          rootMargin: '-75% 0% 0% 0%',
        }
      )

      window.addEventListener('resize', function () {
        // no sticky and we are on mobile/tablet, starting observing target
        if (!bestOfferSticky && (common.isMobile() || common.isTablet())) {
          bestOfferObserver.observe(targetEl)
          bestOfferSticky = true
          // sticky and we are changing sizes, unobserve and observe again to get the right position
        } else if (bestOfferSticky && (common.isMobile() || common.isTablet())) {
          bestOfferObserver.unobserve(targetEl)
          bestOfferObserver.observe(targetEl)
        } else if (bestOfferEl) {
          bestOfferObserver.unobserve(targetEl)
          bestOfferEl.classList.remove('best-offer--hidden')
          bestOfferSticky = false
        }
      })

      if (common.isMobile() || common.isTablet()) {
        bestOfferObserver.observe(targetEl)
        bestOfferSticky = true
      }
    }
  }
}
